import { Component, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { RoundsConfiguration } from '../modules/entry-control/interfaces/rounds_configuration';
import { Helps } from '../libs/helps';
import { Users } from '../models/interfaces/users';
import { SidebarService } from '../services/sidebar.service';
import { CentralistModeService } from '../services/centralist-mode.service';

@Component({
  selector: 'app-private',
  templateUrl: './private.component.html',
  styleUrls: ['./private.component.css']
})
export class PrivateComponent implements OnInit, OnChanges, OnDestroy {

  private sidebarSubscription: Subscription;
  private routeSubscription: Subscription;
  sidebarVisible = true;

  constructor(
    private modal: NgbModal, 
    private router: Router, 
    private helps: Helps,
    private sidebarService: SidebarService,
    private centralistModeService: CentralistModeService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.level = this.helps.getToken()?.level;
    let data = this.helps.getToken()?.data as Users;
    this.sendInme = data?.send_rounds_immediate;
    this.sendProg = data?.send_rounds_program;
  }
  /** Las pantallas de solo consulta de la Central (subrutas) no ofrecen el botón de envío de rondas, propio de la administración. */
  readOnlyView = false;
  level: number = 0;
  sendProg: number = 0;
  sendInme: number = 0;

  ngOnInit(): void {
    this.level = this.helps.getToken()?.level;
    let data = this.helps.getToken()?.data as Users;
    this.sendInme = data?.send_rounds_immediate;
    this.sendProg = data?.send_rounds_program;

    this.sidebarSubscription = this.sidebarService.isSidebarVisible().subscribe(visible => {
      this.sidebarVisible = visible;
    });

    // Sistema de diseño común (clase body.cp-ds): rige en toda la administración excepto la Central de Seguridad,
    // que conserva su diseño propio.
    this.applyDesignSystem(this.router.url);
    this.routeSubscription = this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        this.applyDesignSystem(e.urlAfterRedirects);
      }
    });

    // Redirect to security center if in centralist mode, unless already there
    // (incluye subrutas como /central-de-seguridad/instalacion/:id)
    if (this.centralistModeService.isCentralistMode() && !window.location.pathname.startsWith('/central-de-seguridad')) {
      this.router.navigate(['/central-de-seguridad']);
    }
  }

  ngOnDestroy(): void {
    if (this.sidebarSubscription) {
      this.sidebarSubscription.unsubscribe();
    }
    this.routeSubscription?.unsubscribe();
    document.body.classList.remove('cp-ds');
  }

  private applyDesignSystem(url: string): void {
    document.body.classList.toggle('cp-ds', !url.startsWith('/central-de-seguridad'));
    this.readOnlyView = url.startsWith('/central-de-seguridad/');
  }

  openModal(md: any, size: string = "md") {
    this.modal.open(md, { size: size, backdrop: 'static' });
  }
  goToEditSheduled(data: RoundsConfiguration) {
    if (data?.rounds_type_id != 3) {
      this.router.navigate(['control-ingreso/rondas/editar/' + data?.id]);
    }

  }
}